module.exports = __webpack_public_path__ + "static/media/Aveny soffa liver 3491 ben 051 valnöt detalj 11.ff301b7e.jpg";